import axios from "axios";
import { store } from "../store/store";
import { logout } from "../features/userSlice";

const token = localStorage.getItem("token");

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Authorization: token ? token : "",
    "Content-Type": "application/json",
    Accept: "Application/json",
  },
  timeout: 100000 * 6, //One minute
});

//configure to add new token to request if even new
axiosClient.interceptors.request.use((config) => {
  const newToken = localStorage.getItem("token");
  if (newToken) {
    config.headers.Authorization = newToken;
  }
  return config;
});

//Remove token if Token expires or logged out
axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response &&
      error.response.data.code === 401 &&
      error.response.data.message === "Access Denied, please Sign In"
    ) {
      localStorage.removeItem("token");
      store.dispatch(logout());
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
